import { ReactComponent as Edit } from "../../svg/edit.svg";
import { CustomButton } from "../CustomButton";
import { useSelector } from "react-redux";
import { selectActiveBotFlowState } from "../../hooks/useActiveBotFlow";
function EditButton({ onClick }) {
  const { isEditable } = useSelector(selectActiveBotFlowState);
  return (
    <CustomButton
      varient="icon-button  absolute"
      style={{ top: 0, right: 0 }}
      onClick={onClick}
      icon={<Edit />}
      disabled={!isEditable}
    />
  );
}

export default EditButton;
